import React, { Component } from "react"
import PropTypes from "prop-types"

export default class Field extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    getInitialValue: PropTypes.func,
    getError: PropTypes.func
  }

  constructor(props, context) {
    super(props)
    if (props.value) {
      this.state = { value: props.value }
    } else {
      this.state = {
        value: context.getInitialValue
          ? context.getInitialValue(this.props.name)
          : null
      }
    }
  }

  onChange(event) {
    if (this.context.onChange) {
      this.context.onChange(this.props.name, event.target.value)
    }

    if (this.props.onChange) {
      this.props.onChange(event)
      return
    }

    this.setState({ value: event.target.value })
  }

  renderError() {
    if (this.context.getError) {
      const error = this.context.getError(this.props.name)
      if (error) {
        return (
          <span className="error">
            {Array.isArray(error) ? error.join("; ") : error}
          </span>
        )
      }
    }
  }

  render() {
    return (
      <label htmlFor={this.props.name}>
        <span>{this.props.label}</span>
        {this.props.type === "textarea" ? (
          <textarea
            step={this.props.step}
            name={this.props.name}
            rows={this.props.rows || 4}
            onChange={this.onChange.bind(this)}
            value={
              this.props.value ||
              this.state.value ||
              this.props.defaultValue ||
              ""

            }
          />
        ) : (
          <input
            type={this.props.type}
            step={this.props.step}
            name={this.props.name}
            onChange={this.onChange.bind(this)}
            value={
              this.props.value ||
              this.state.value ||
              this.props.defaultValue ||
              ""
            }
          />
        )}

        {this.renderError()}
      </label>
    )
  }
}

Field.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  step: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  rows: PropTypes.string,
  onChange: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/fields/Field.js